import React from 'react';
import {
    Autocomplete,
    Checkbox,
    FormControl,
    Popper,
    Skeleton,
    styled,
    TextField,
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useTranslation } from 'react-i18next';

const StyFormControl = styled(FormControl)(() => ({
    '& .MuiInputBase-root': {
        backgroundColor: 'white',
    },
    '& .Mui-disabled': {
        color: 'black', // text color
        backgroundColor: 'transparent',
    },
    width: '100%',
    height: '100%',
}));

type Props = {
    data: string | string[];
    setData: (data: string | string[]) => void;
    dataList: string[];
    isLoading: boolean;
    title: string;
    placeholder: string;
    multiple?: boolean;
};
const HrSelect = ({
    data,
    setData,
    dataList,
    isLoading,
    title,
    placeholder,
    multiple = false,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <StyFormControl required fullWidth>
            {isLoading ? (
                <Skeleton width="100%" height={60} />
            ) : (
                <>
                    <Autocomplete
                        id="cadre-emplois-select"
                        options={dataList}
                        value={data}
                        multiple={multiple}
                        disableCloseOnSelect={multiple}
                        onChange={(_, v) => setData(v ?? '')}
                        noOptionsText={t('humanResources.simulation.noOptions')}
                        // eslint-disable-next-line react/no-unstable-nested-components
                        PopperComponent={({ style, ...props }) => (
                            <Popper
                                {...props}
                                style={{ ...style, height: 0 }} // width is passed in 'style' prop
                            />
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={title}
                                placeholder={placeholder}
                            />
                        )}
                        renderOption={(props, id, { selected }) => (
                            <li {...props} key={id}>
                                {multiple && (
                                    <Checkbox
                                        icon={
                                            <CheckBoxOutlineBlankIcon fontSize="small" />
                                        }
                                        checkedIcon={
                                            <CheckBoxIcon fontSize="small" />
                                        }
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                )}
                                {id}
                            </li>
                        )}
                    />
                </>
            )}
        </StyFormControl>
    );
};
export default HrSelect;
